import {
  POLL_LIST,
  SELECT_LIST_TYPE,
  POLL_EXPORT_MODAL,
  BROADCAST_POLLS,
} from "PollAction";

export function pollList(state = {}, action) {
  switch (action.type) {
    case POLL_LIST:
      return action.payload;
    default:
      return state;
  }
}
export function selectPollListType(state = {}, action) {
  switch (action.type) {
    case SELECT_LIST_TYPE:
      return action.payload;
    default:
      return state;
  }
}

export var ShowPollExportModal = (state = { show: false, key: "" }, action) => {
  if (action.type === POLL_EXPORT_MODAL) {
    return action.payload;
  }
  return state;
};

/* Stort Live Polls Modal [Actions name -> broadcastPolls] */
export function broadcastLivePolls(state = {}, action) {
  switch (action.type) {
    case BROADCAST_POLLS:
      return action.payload;
    default:
      return state;
  }
}
